type PageLayoutFooterProps = { children: React.ReactNode; className?: string }
export function PageLayoutCustomFooter({ children, className }: Readonly<PageLayoutFooterProps>) {
  return (
    <div className={'PageLayoutFooter ' + className}>
      <div className="PageLayoutFooter__content">{children}</div>
    </div>
  )
}
